// Events for amplitude tracking
export enum AdminIncentiveTrackingEvent {
	// Index page actions
	CreateIncentive = 'Admin Index Create Incentive',
	SelectIncentive = 'Admin Select an Incentive',
	ReviewPosts = 'Admin Review Incentive Posts',
	IncentiveSummary = 'Admin Click Incentive Summary',
	EditIncentive = 'Admin Edit Incentive',
	ReviewArchivedIncentives = 'Admin Review Archived Incentives',
	ApproveIncentive = 'Admin Index Approve Incentive',
	ChoosePending = 'Admin Select Pending Incentive',
	IndexPaginate = 'Admin Index Paginate',
	SortIncentives = 'Admin Index Sort Incentives',

	// Archived index page actions
	ArchivedSelectIncentive = 'Admin Archived Index Select Incentive',
	ArchivedEditIncentive = 'Admin Archived Index Edit Incentive',
	ArchivedDeleteIncentive = 'Admin Archived Index Delete Incentive',
	ArchivedPaginate = 'Admin Archived Index Paginate',
	ArchivedSortIncentives = 'Admin Archived Index Sort Incentives',
	ArchivedReviewPosts = 'Admin Archived Index Review Posts',

	// Modals
	DeactivateIncentive = 'Admin Deactivate Incentive',
	ReactivateIncentive = 'Admin Reactivate Incentive',
	DeleteIncentive = 'Admin Delete Incentive',

	// Form actions
	RequireProof = 'Admin Incentive Form Require Proof Toggle',
	BasicInfoPreview = 'Admin Incentive Form Open Basic Info Preview',
	RecognitionPostPreview = 'Admin Incentive Form Open Recognition Post Preview',
	FilterAudienceButton = 'Admin Incentive Form Select Filter Audience Button',
	SetPointsBudget = 'Admin Incentive Form Set Points Budget',
	SetApprovalProcess = 'Admin Incentive Form Set Approval Process',
}
